import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import UserForm from "../components/UserForm/UserForm";

const ProtectedRoute = ({ component: Component }) => {
  const { user } = useAuth();
  
  return user ? <Component /> : <UserForm />;
};

export default ProtectedRoute;